import { cast, types } from 'mobx-state-tree';
import { logout } from 'service/session-api';
import { WebContents } from 'types/electron';

const { settings } = window;

const IframeHistory = types
    .model('IframeHistory', {
        url: types.optional(types.string, ''),
        history: types.optional(types.array(types.string), []),
        historyIndex: types.optional(types.number, -1),
    })
    .views((self) => ({
        get canGoBack() {
            return self.historyIndex >= 0;
        },
        get canGoForward() {
            return self.history.length > self.historyIndex + 1;
        },
    }))
    .actions((self) => {
        const actions = {
            goBack() {
                if (!self.canGoBack) return false;
                self.historyIndex--;
                document.getElementsByTagName('iframe')[0].contentWindow?.history.back();
                if (!self.canGoBack) return false;
                // if (self.historyIndex < 0) return false;
                // self.url = self.history[self.historyIndex];
                return true;
            },
            goForward() {
                if (!self.canGoForward) return false;
                self.historyIndex++;
                document.getElementsByTagName('iframe')[0].contentWindow?.history.forward();
                // self.url = self.history[self.historyIndex];
                return true;
            },
            add(url: string) {
                if (self.url === url) return; // ignore to store initial iframe url because it will be handled by parent's webContents history (ex. /main/web/account-settings)
                while (self.history.length > self.historyIndex + 1) {
                    self.history.pop();
                }
                self.history.push(url);
                self.historyIndex += 1;
                // console.log('add', self.historyIndex);
            },
            clear() {
                self.url = '';
                self.history = cast([]);
                self.historyIndex = -1;

                // console.log('clear', self.historyIndex);
            },
            setUrl(url: string) {
                actions.add(url);
                self.url = url;
            },
        };
        return actions;
    });

const HistoryStore = types
    .model('History', {
        _canGoBack: types.optional(types.boolean, false),
        _canGoForward: types.optional(types.boolean, false),
        iframe: types.optional(IframeHistory, {}),
    })
    .volatile((self) => ({
        webContents: null as any,
    }))
    .views((self) => ({
        get canGoBack() {
            return self.iframe.canGoBack || self._canGoBack;
        },
        get canGoForward() {
            return self.iframe.canGoForward || self._canGoForward;
        },
    }))
    .actions((self) => {
        const actions = {
            check() {
                self._canGoBack = self.webContents.canGoBack();
                self._canGoForward = self.webContents.canGoForward();
            },
            goBack() {
                if (!self.iframe.goBack()) self.webContents.goBack();
                setTimeout(() => {
                    actions.check();
                }, 0);
            },
            goForward() {
                if (!self.iframe.goForward()) self.webContents.goForward();
                setTimeout(() => {
                    actions.check();
                }, 0);
            },
        };
        return actions;
    })
    .actions((self) => ({
        attach(contents: WebContents) {
            self.webContents = contents;
            // contents.clearHistory();
            contents.on('did-navigate', () => {
                self.check();
            });
            contents.on('did-navigate-in-page', (url, isMainFrame) => {
                console.log('did-navigate-in-page', url, isMainFrame);

                self.check();
                if (isMainFrame) {
                } else {
                    if (!self.iframe.url) return; // if iframe component is not initialized, skip
                    const accountBaseUrl = `${settings.hosts.accounts}/account/[^/]+/`;
                    // login main page
                    if (new RegExp(`${accountBaseUrl}login($|[^-^/])`).test(url)) {
                        // $('.wrapper').startWaiting({ css: { opacity: 0.8, zIndex: 1000, backgroundColor: '#000' } }); /// needs to convert to react
                        logout(); // logout launcher
                        return;
                    }
                    self.iframe.add(url);
                }
            });
        },
        detach() {
            self.webContents.removeAllListeners('did-navigate');
            self.webContents.removeAllListeners('did-navigate-in-page');
        },
    }));

export default HistoryStore;
